export default "__VITE_ASSET__97b17e12__"